import i18next from 'i18next';
import { RecordTypeEnum } from 'src/api/models/Enums';
import { Markets } from 'src/types';
import { isMarket } from 'src/utils/markets';
import * as Yup from 'yup';

export const createReportValidationSchema = Yup.object().shape({
	RecordTypeId: Yup.string().required(i18next.t('required_field')),
	RecordType: Yup.string().required(i18next.t('required_field')),
	FirstName: Yup.string().when('RecordTypeId', {
		is: (value: RecordTypeEnum) =>
			[RecordTypeEnum.Libero_Professionista, RecordTypeEnum.Privato].includes(
				value
			),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	LastName: Yup.string().when('RecordTypeId', {
		is: (value: RecordTypeEnum) =>
			[RecordTypeEnum.Libero_Professionista, RecordTypeEnum.Privato].includes(
				value
			),
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Company: Yup.string().when('RecordTypeId', {
		is: (value: RecordTypeEnum) => value === RecordTypeEnum.Azienda,
		then: (schema) => schema.required(i18next.t('required_field')),
	}),
	Codice_Fiscale__c: Yup.string().when('RecordTypeId', {
		is: (value: RecordTypeEnum) => value === RecordTypeEnum.Privato,

		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.required(i18next.t('required_field'))
					.length(
						16,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					)
					.matches(
						/^[A-Z0-9]{16}$/,
						i18next.t('codice_fiscale_format_error_16_chars_no_symbols')
					);
			}
			if (isMarket(Markets.es)) {
				return schema
					.required(i18next.t('required_field'))
					.length(9, i18next.t('codice_fiscale_format_error_9_chars'));
			}
			return schema.required(i18next.t('required_field'));
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	Partita_IVA__c: Yup.string().when('RecordTypeId', {
		is: (value: RecordTypeEnum) =>
			[RecordTypeEnum.Azienda, RecordTypeEnum.Libero_Professionista].includes(
				value
			),
		then: (schema) => {
			if (isMarket(Markets.it)) {
				return schema
					.required(i18next.t('required_field'))
					.length(11, i18next.t('business_fiscal_code_length_error_11_chars'))
					.matches(
						/^\d{11}$/,
						i18next.t('business_fiscal_code_length_error_11_chars')
					);
			}
			if (isMarket(Markets.es)) {
				return schema
					.required(i18next.t('required_field'))
					.length(9, i18next.t('business_fiscal_code_length_error_9_chars'));
			}
			return schema.required(i18next.t('required_field'));
		},
		otherwise: (schema) => schema.notRequired(),
	}),
	Email__c: Yup.string()
		.email(i18next.t('email_not_valid'))
		.required(i18next.t('email_mandatory')),
	Phone: Yup.string()
		.matches(
			/^\+?\d{1,3}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/,
			i18next.t('phone_not_valid')
		)
		.required(i18next.t('phone_mandatory')),
	Marca__c: Yup.string().required(i18next.t('required_field')),
	Modello__c: Yup.string().required(i18next.t('required_field')),
});
